// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_2HD","cls2":"PaperClaiming-cls2_iXQ PaperClaiming-cls1_2HD"};